import { omit } from 'lodash-es';

import { formatDate } from '@utils';

export const getVehiclePayload = (values) => {
  const cleanedValues = omit(values, [
    'agreedCustomsDate',
    'estimatedCustomsDate',
    'customsEntryDate',
    'plannedDownpaymentDate',
    'discountPercentage',
    'discountWithoutVat',
    'classificationCosts',
    'agreedPurchasePrice',
    'finalPurchasePrice',
    'buyoutPrice',
    'buyoutMonths',
  ]);
  const payload = {
    ...cleanedValues,
    orderDate: formatDate(values.orderDate, 'yyyy-MM-dd'),
    quantity: Number(values.quantity),
    vat: Number(values.vat),
    tenant: Number(values.tenant),
    procurement: {
      agreedCustomsDate: values.agreedCustomsDate
        ? formatDate(values.agreedCustomsDate, 'yyyy-MM-dd')
        : undefined,
      estimatedCustomsDate: values.estimatedCustomsDate
        ? formatDate(values.estimatedCustomsDate, 'yyyy-MM-dd')
        : undefined,
      customsEntryDate: values.customsEntryDate
        ? formatDate(values.customsEntryDate, 'yyyy-MM-dd')
        : undefined,
      plannedDownpaymentDate: values.plannedDownpaymentDate
        ? formatDate(values.plannedDownpaymentDate, 'yyyy-MM-dd')
        : undefined,
      discountPercentage: values.discountPercentage
        ? Number(values.discountPercentage)
        : null,
      discountWithoutVat: values.discountWithoutVat || undefined,
      classificationCosts: values.classificationCosts || undefined,
      agreedPurchasePrice: values.agreedPurchasePrice || undefined,
      finalPurchasePrice: values.finalPurchasePrice || undefined,
      buyoutPrice: values.buyoutPrice || undefined,
      buyoutMonths: values.buyoutMonths
        ? Number(values.buyoutMonths)
        : undefined,
    },
  };

  return payload;
};
